import CardFlag from "./CardFlag";

export default CardFlag;
